import React, { StrictMode, useEffect } from 'react';

import PropTypes from 'prop-types';

import Table from 'components/new_ui/Table';

import useTeams from 'components/Common/Managers/Hooks/useTeams';

import { useContext as useTemplateContext } from 'components/Managers/Templates/Context';
import columns from './columns';
import NoData from './NoData';

export default function Index({ members, onFilteredDataChange }) {
  const teams = useTeams();

  const { dispatch: dispatchTemplates, actions: actionsTemplates, state: stateTemplates } = useTemplateContext();

  const rowActions = [
    {
      type: 'EXPAND',
    },
  ];

  const templates = (stateTemplates.templates || []).map((item) => item.attributes.title);

  useEffect(() => {
    actionsTemplates.load(dispatchTemplates, stateTemplates.enterpriseId);
  }, []);

  return (
    <StrictMode>
      <h1>Member List</h1>

      <section className="pt-2">
        <Table
          title=" "
          selectableRows={false}
          columns={columns(teams, templates)}
          data={members}
          loading={members == null}
          rowActions={rowActions}
          noData={<NoData />}
          onFilteredDataChange={onFilteredDataChange}
        />
      </section>

    </StrictMode>
  );
}

Index.propTypes = {
  members: PropTypes.arrayOf(PropTypes.object),
  onFilteredDataChange: PropTypes.func.isRequired,
};

Index.defaultProps = {
  members: null,
};
